// Cosyworld design tokens (from the design brief §2).
export const COLORS = {
  ink: '#2B3136',
  accent: '#E7A569',
  accentDark: '#CF8B45',
  accentText: '#C49A6A',
  pageBg: '#F6F5F3',
  card: '#FFFFFF',
  soft: '#FAF8F5',
  border: '#E8E5E0',
  borderSoft: '#F0ECE6',
  positive: '#2E9E6B',
  positiveSoft: '#7FD3A6',
  negative: '#CF4B3E',
  muted: '#8a8f94',
  muted2: '#A8A39D',
  blue: '#4A7FB5',
  teal: '#5BA3A0',
  rose: '#C97B84',
  gray: '#9A948D',
  spendBar: '#D9D2C8',
} as const;

/** ROAS → status colour (red < 3.5 < amber < 4.1 < green). */
export function roasColor(r: number): string {
  if (r >= 4.1) return COLORS.positive;
  if (r >= 3.5) return COLORS.accent;
  return COLORS.negative;
}
